import React, { Component } from "react";
import GLOBALS from '../utils/Constants';
import CryptoJS from 'crypto-js'
import moment from 'moment-timezone';
import UserService from './users-service';


export default class FilesService {

    static sharedInstance = FilesService.sharedInstance == null ? new FilesService() : this.sharedInstance;

    constructor() {
        //UserService.sharedInstance.checkIfTokenIsValid();
    }


    async uploadLogo(params){
        const data = new FormData();

        data.append("file", params.file);
        data.append("auth_username", params.auth_username);
        data.append("token", params.token);
        data.append("license", params.license);
        data.append("type", params.type)

        const response = await fetch(GLOBALS.UPLOAD_LOGO_API, {
            method: 'POST',
            body: data
        });

        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error(error);
        }
    }


    async deleteLogo(params){
        const formBody = UserService.sharedInstance.urlEncodeParams(params);

        const response = await fetch(GLOBALS.DELETE_LOGO_API, {
            method: 'DELETE',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded',
            },
            body: formBody
        });
        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error(error);
        }
    }

    getLogo = (data,callback) =>{
        try{
            const param = UserService.sharedInstance.urlEncodeParams(data);
            fetch(GLOBALS.GET_LOGO_BY_TYPE_API + '&' + param)
                .then(res => res.json())
                .then(res => {
                    UserService.sharedInstance.checkIfTokenIsValid(res);
                    callback(res);
                }).catch(err => {
                    console.error('Error:',err);
                    callback({
                        success:0,
                        code_error:'server_error',
                        message:err.message
                    });
                });
        }catch(err){
            console.error('Error:',err);

            callback({
                success:0,
                code_error:'server_error',
                message:err.message
            });
        }
    }
}